<template>
    <div class="form-group">
        <div class="input selectbox" :class="{ '-required': props.required }">
            <input type="text" class="form-control" :class="{ '-filled': inputValue }" :name="props.identifier + 'Search'" :id="props.identifier + 'Search'" v-model="inputValue" :required="props.required" ref="input"/>
            <div class="input-background">
                <label class="control-label" :for="props.identifier + 'Search'">{{ props.label }}</label>
            </div>
        </div>
    </div>
</template>

<script setup>
/* global countrySearch */
import { ref, defineEmits, defineProps, onMounted } from 'vue'

const props = defineProps({
  required: {
    type: Boolean,
    default: false
  },
  identifier: {
    type: String,
    default: ''
  },
  label: {
    type: String,
    default: ''
  }
})

const emit = defineEmits(['predictionSelected'])

const inputValue = ref('')

const countrySeachAutocomplete = countrySearch.autocomplete
const input = ref(null)
onMounted(() => {
  countrySeachAutocomplete.init(input.value, window.app.partnumber_search_extended.formCountries)
  countrySeachAutocomplete.addEventListener('prediction_selected', () =>
  {
    if (countrySeachAutocomplete.selected)
    {
      inputValue.value = countrySeachAutocomplete.selected.label
      emit('predictionSelected', countrySeachAutocomplete.selected.value)
    }
  })
})
</script>
